var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.209961 8.99993C0.209961 8.3293 0.757495 7.78564 1.43291 7.78564H19.7772C20.4526 7.78564 21.0001 8.3293 21.0001 8.99993C21.0001 9.67056 20.4526 10.2142 19.7772 10.2142H1.43291C0.757495 10.2142 0.209961 9.67056 0.209961 8.99993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41231 17.1443C7.93472 17.6186 7.16039 17.6186 6.6828 17.1443L1.0746 11.5759C-0.358176 10.1533 -0.358171 7.84673 1.0746 6.42411L6.6828 0.855656C7.16039 0.381447 7.93472 0.381447 8.41231 0.855656C8.8899 1.32986 8.8899 2.09871 8.41231 2.57292L2.80412 8.14137C2.32652 8.61558 2.32653 9.38442 2.80412 9.85863L8.41231 15.4271C8.88991 15.9013 8.88991 16.6701 8.41231 17.1443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.40a2040bae1c24cd043249d3e69820a8.svg";
export { ForwardRef as ReactComponent };